<template lang="pug">
  v-select(
    @input='$emit("update", block)'
    v-model='block.value'
    :items='list'
    item-value='id'
    item-text='name'
    label='Выберите баннер'
  )
</template>

<script>
import http from '@/http'
import BaseBlock from './BaseBlock'

export default {
  extends: BaseBlock,

  data: function() {
    return {
      list: []
    }
  },

  async created() {
    try {
      const response = await http.get('seo/banners/list')
      this.list = response.data
    } catch (e) {
      this.$root.showSnack('Ошибка загрузки баннеров')
    }

  }
}
</script>
